import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    // Redirect authenticated users to appropriate dashboard
    const from = location.state?.from?.pathname || '/dashboard';
    
    if (user?.role === 'ADMIN') {
      return <Navigate to="/admin" replace />;
    }
    
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
